import vue from "vue";
export default (() => {
    vue.filter("toNumCNDate", date => {
        if (!date) {
            return "";
        }
        date = new Date(date).toLocaleDateString();
        let arr = date.split("/");
        return `${arr[1]}月${String(arr[2]).padStart(2, "0")}日`;
    });
    vue.filter("toCNWeek", date => {
        if (!date) {
            return "";
        }
        let argDateObj = new Date(date);
        let argYear = argDateObj.getFullYear();
        let argMonth = argDateObj.getMonth();
        let argDate = argDateObj.getDate();
        let nowYear = new Date().getFullYear();
        let nowMonth = new Date().getMonth();
        let nowDate = new Date().getDate();
        if (argYear == nowYear && argMonth == nowMonth && argDate == nowDate) {
            return "今天";
        } else if (argYear == nowYear && argMonth == nowMonth && argDate - nowDate == 1) {
            return "明天";
        } else if (argYear - nowYear == 1 && argMonth == 0 && argDate == 1) {
            return "明天";
        }
        let week = argDateObj.getDay();
        let weeks = ["一", "二", "三", "四", "五", "六", "日"];
        if (week >= 1 && week <= 7) {
            return `周${weeks[week - 1]}`;
        } else {
            return `周${weeks[0]}`;
        }
    });
    vue.filter("toYearMonthDate", date => {
        date = new Date(date);
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    });
    vue.filter("toYMDHMS", date => {
        if (!date) {
            return "";
        }
        date = new Date(date);
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date
            .getDate()
            .toString()
            .padStart(2, "0")} ${date
            .getHours()
            .toString()
            .padStart(2, "0")}:${date
            .getMinutes()
            .toString()
            .padStart(2, "0")}:${date
            .getSeconds()
            .toString()
            .padStart(2, "0")}`;
    });
    vue.filter("fixedPrice", price => {
        if (!price) return "0.00";
        return Number(price).toFixed(2);
    });
    vue.filter("getImageUrl", filePath => {
        let uploadsUrl = process.env.VUE_APP_BASEURL;
        if (!filePath) {
            return "";
        } else if (filePath.indexOf("http") == 0) {
            return filePath;
        } else {
            //上传地址以 / 结尾且文件路径也以 / 开头
            if (uploadsUrl.lastIndexOf("/") == uploadsUrl.length - 1 && filePath.indexOf("/") == 0) {
                return uploadsUrl + filePath.substr(1);
            }
            //上传地址以 / 结尾且文件路径不以 / 开头   或   上传地址不以 / 结尾且文件路径以 / 开头
            if (
                (uploadsUrl.lastIndexOf("/") == uploadsUrl.length - 1 && filePath.indexOf("/") != 0) ||
                (uploadsUrl.lastIndexOf("/") != uploadsUrl.length - 1 && filePath.indexOf("/") == 0)
            ) {
                return uploadsUrl + filePath;
            }
            //上传地址、文件路径都以 / 结尾/开头
            if (uploadsUrl.lastIndexOf("/") != uploadsUrl.length - 1 && filePath.indexOf("/") != 0) {
                return uploadsUrl + "/" + filePath;
            }
            return "";
        }
    });
    vue.filter("cutCardNumber", val => {
        if (val) {
            if (val.length > 4) {
                let strVal = String(val);
                return `(${strVal.substr(strVal.length - 4)})`;
            } else {
                return "****";
            }
        } else {
            return "";
        }
    });
})();
